var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-navigation-layout', {
    attrs: {
      "items": _vm.items,
      "title": _vm.$t('views.report.my.title')
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }